<template>
    <div>
        <div class="ul-top box-sizing">
            <div class="btn-features">
                <el-button type="success" @click="flowRecharge">新建访问包</el-button> <span style="color:#f76a1a;font-size: 12px;display: inline-block;background: #f7f7ea;padding:2px 10px;">如果访问包用完将会跳转到广告，请做好充足或备用访问包，谢谢支持！</span>
            </div>
        </div>
        <div class="ul-mid box-sizing">
            <el-table v-loading="isLoading" :data="tableData"  empty-text="暂无数据" @selection-change="handleSelectionChange">
                <el-table-column prop="flow_pack_name" label="访问包" class-name="text-align"></el-table-column>
                <el-table-column prop="create_time" label="添加日期"></el-table-column>
                <el-table-column prop="status" label="状态">
                    <template slot-scope="scope">
                        <span  v-if="scope.row.status==1" style="color:darkgreen;">运行中</span>
                        <span  v-if="scope.row.status==0" style="color:#ff0000;">已失效</span>
                    </template>
                </el-table-column>
                <el-table-column prop="flow_pack" label="已用/可用数量" class-name="text-align">
                    <template slot-scope="scope">
                        <span style="display: block;background: #eef8e6;width:200px;height:30px;line-height: 30px;font-size: 12px; position: relative;">
                            <em style="background:#f6dddd;width:0px;left:0px;position: absolute;top:0px;height:30px;z-index: 1;" v-bind:style="{width:parseInt(scope.row.use_flow/scope.row.flow_pack*200)+'px'}"></em>
                            <em style="position: relative;z-index: 2;font-style: inherit;">{{scope.row.use_flow}}/{{scope.row.flow_pack}}</em>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="expire_time" label="到期时间"></el-table-column>
            </el-table>
            <div class="pagebar" v-show="total>5">
                <el-pagination background layout="total, prev, pager, next, jumper" :total="total" @current-change="handleCurrentPage"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "FlowPackList",
        data() {
            return {
                total: 0,
                keyword: "",
                selUrlID: "",
                timeGroup: [],
                tableData: [],
                isLoading: false,
                currentPage: 1,
                addLabelLoad: false,
                addLabelDialog: false,
            }
        },
        mounted() {
            setTimeout(this.getList,200);
        },
        methods: {
            async getList() {
                this.isLoading = true;
                const {ret,data} = await this.$api.flowPack.getFlowList();
                this.isLoading = false;
                if (ret === 1000){
                    this.total = Number(data['total']);
                    this.tableData = data['list'];
                }
            },
            flowRecharge() {
                this.$router.push('/tabs/flowRecharge');
            },
            handleCurrentPage() {

            },
            handleSelectionChange() {

            },
        }
    }
</script>

<style scoped>
    .ul-top{
        width: 100%;
        height: auto;
        padding: 20px;
    }
    .ul-top .ul-item{
        width: 100%;
        height: 40px;
        color: #666666;
        margin-bottom: 10px;
    }
    .ul-top .ul-item .lab{
        display: inline-block;
        width: 70px;
        height: 40px;
        font-size: 14px;
        line-height: 40px;
        text-align: right;
        margin-right: 10px;
        vertical-align: top;
    }
    .ul-top .ul-item .opt{
        display: inline-block;
        width: 350px;
        height: 40px;
        vertical-align: top;
    }
    .ul-top .ul-item .btn{
        display: inline-block;
        width: 70px;
        height: 40px;
        margin-left: 10px;
        vertical-align: top;
    }
    .ul-top .ul-item .inp{
        width: 350px;
    }
    .ul-top .btn-features{
        width: 100%;
        height: 40px;
        margin-top: 30px;
    }
    .ul-mid{
        width: 100%;
        padding: 0 20px;
    }
    .ul-mid .pagebar{
        width: 100%;
        height: 52px;
        margin-top: 20px;
    }
</style>
